import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'
import {message} from 'antd'

class ManualStore {
  // 数据
  @observable level1Directory
  @observable childrenDirectory
  @observable content
  @observable carSeriesName
  @observable directoryName
  @observable search
  @observable searchList
  @observable printContent
  // 控制
  @observable carSeriesId
  @observable level1Selected
  @observable childrenSelected
  @observable openKeys
  @observable loading
  @observable modal



  constructor () {
    this.level1Directory = []
    this.childrenDirectory = []
    this.content = []
    this.printContent = []
    this.carSeriesName = ''
    this.directoryName = ''
    this.carSeriesId = ''
    this.level1Selected = ''
    this.childrenSelected = ''
    this.openKeys = []
    this.loading = false
    this.search = ''
    this.searchList = []
    this.modal = 'hide'
  }


//
  @action
  init = async (carSeriesId,level1Selected,directoryId) => {
    runInAction(()=>{
      this.content = [];
    })
    const carSeries = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/carseriesCatalog/id/${carSeriesId}`)
    if(carSeries && carSeries.status === 0){
      return;
    }
    runInAction(() => {
      this.carSeriesName = carSeries.carseriesName
    })
    await this.__findDirectoryByDirectoryId(carSeriesId,level1Selected, directoryId)
  }

  @action
  getChildrenTree = async (level1Selected) => {
    runInAction(() => {
      this.loading = true
    })
      const childrenDirectory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/childrenList?carseriesId=${this.carSeriesId}&pId=${level1Selected}`)
    if (!childrenDirectory.length) {
        runInAction(() => {
            this.loading = false
        })
        return;
    }
    const {path, name} = this.__findChildrenDirectoryPathAndName(childrenDirectory)
    const directoryId = path[path.length - 1]
    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=${directoryId}`)
    runInAction(() => {
      this.childrenDirectory = childrenDirectory
      this.level1Selected = level1Selected
      this.childrenSelected = directoryId
      this.content = content
      this.openKeys = path.slice(0, path.length - 1)
      this.directoryName = name
      this.loading = false
    })
  }

  @action showContent =  async(id, name) => {
    runInAction(() => {
      this.loading = true
    })
    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=${id}`)
    if(content && content.status === 0){
      runInAction(()=>{
        this.loading = false;
      })
      return
    }
    runInAction(() => {
      this.childrenSelected = id
      this.content = content
      this.directoryName = name
      this.modal = 'hide'
      this.loading = false
    })
  }

  @action showContentBySearch =  async(id, name) => {
    runInAction(() => {
      this.loading = true
    })
    const res =await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog:findByLast?id=${id}`)
    const path = res.data.split('/')
    const childrenDirectory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/childrenList?carseriesId=${this.carSeriesId}&pId=${path[0]}`)
    const content =await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=${id}`)
    if(content && content.status === 0){
      runInAction(()=>{
        this.loading = false;
      })
      return
    }
    runInAction(() => {
      this.level1Selected = path[0];
      this.childrenDirectory = childrenDirectory
      this.openKeys = path.slice(0, path.length - 1)
      this.childrenSelected = id
      this.content = content
      this.directoryName = name
      this.modal = 'hide'
      this.loading = false
    })
  }


  @action.bound
    openMenu = (openKeys) => {
      this.openKeys = openKeys
    }

    @action submitEdit = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/comment`,this.forms)
        if (res && res.status === 0) {
            return
        }
      runInAction(() => {
        this.loading = false;
      })
      message.success('评论成功！')
      await this.getComments();
    }

    @action getSearch = (value) =>{
      runInAction(()=>{
        this.search = value;
      })
    }
    //根据查询条件获取四级目录列表
    @action showList = async() =>{
      if(this.search === ''){
        message.warning('请输入四级目录名称！');
        return
      }
      runInAction(()=>{
        this.loading = true;
      })
      const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/selectByName?defaultName=${this.search}&carseriesId=${this.carSeriesId}`)
      if (res && res.status === 0) {
        return
      }
      runInAction(()=>{
        this.searchList = res.data
        this.modal = 'show'
        this.loading = false;
      })
    }
    /**
     *取消编辑
     */
    @action.bound
    cancelEdit () {
      this.loading = false
      this.modal = 'hide'
    }

    __findDirectoryByDirectoryId = async (carSeriesId,level1Selected,directoryId) => {
    runInAction(() => {
      this.loading = true
      this.carSeriesId = carSeriesId
      this.level1Directory = [];
      this.childrenDirectory = [];
      this.directoryName = '';
      this.content = [];
    })
    let catalog;
    if (directoryId && directoryId!=='none') {
      catalog = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/${directoryId}`)
    } else {
      catalog = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/by/carseries/${carSeriesId}`)
    }
    if(catalog && catalog.status === 0){
      runInAction(() => {
        this.loading = false
      })
      return
    }
    const path = catalog.path.split('/')
    const level1Directory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/lv1List?carseriesId=${carSeriesId}`)
    if (!level1Directory.length) {
      runInAction(() => {
        this.loading = false
      })
      return
    }
    const childrenDirectory = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/catalog/childrenList?carseriesId=${carSeriesId}&pId=${path[0]}`)
    if (!childrenDirectory.length) {
        runInAction(() => {
            this.loading = false
        })
        return;
    }
    const content = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=${catalog.id}`)
    runInAction(() => {
      this.level1Directory = level1Directory
      this.childrenDirectory = childrenDirectory
      this.level1Selected =level1Selected==='none' ? path[0]:level1Selected
      this.childrenSelected = catalog.id
      this.content = content
      this.openKeys = path.slice(1, path.length - 1)
      this.directoryName = catalog.defaultName
      this.loading = false
    })
  }
  __findChildrenDirectoryPathAndName(directory) {
    let d = directory
    const path = []
    for (let i = 0; i < 20; i++) {
      path.push(d[0].id)
      if (d[0].children.length) {
        d = d[0].children
      } else {
        break
      }
    }
    return {path, name: d[0].defaultName}
  }
}

export default new ManualStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/web/maintain/Manual/store.js